import React from 'react'
import { Waypoint } from 'react-waypoint'

import { EndChapter } from '@components/EndChapter'
import { VerticalStyleProps } from './interface'

export function VerticalStyle({
  Element,
  chapterPages,
  createUserReadingHandler,
}: VerticalStyleProps) {
  return (
    <>
      <div className='flex flex-col m-auto desktop-tablet:w-[700px] desktop-tablet:min-w-[700px] mobile:max-w-screen mobile:w-screen mobile:mx-[calc(calc(-100vw+100%)/2)]'>
        {chapterPages.map(chapterPage => (
          <Element name={`${chapterPage.id}`} key={chapterPage.id}>
            <Waypoint
              onEnter={() => createUserReadingHandler(chapterPage.id)}
            />
            <img src={chapterPage.imgPath} alt='Manga' width='100%' />
          </Element>
        ))}
      </div>
      <EndChapter />
    </>
  )
}
